import { createReducer, on, createFeature } from '@ngrx/store'
import * as PersonalDetailsActions from './family.actions'
import { FamilyState } from './family.state'
import {
  createFamily,
  createFamilyFailure,
  createFamilySuccess,
  deleteFamily,
  deleteFamilyFailure,
  deleteFamilySuccess,
  loadFamilies,
  loadFamiliesFailure,
  loadFamiliesSuccess,
  updateFamily,
  updateFamilyFailure,
  updateFamilySuccess
} from './family.actions'

export const initialState: FamilyState = {
  families: [],
  loading: false,
  error: null
}

export const familyReducer = createReducer(
  initialState,
  on(loadFamilies, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(loadFamiliesSuccess, (state, { families }) => ({
    ...state,
    families: families,
    loading: false,
    error: null
  })),
  on(loadFamiliesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(createFamily, state => ({ ...state, loading: true })),
  on(createFamilySuccess, (state, { family }) => ({
    ...state,
    families: [...state.families, family],
    loading: false
  })),
  on(createFamilyFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(updateFamily, state => ({ ...state, loading: true })),
  on(updateFamilySuccess, (state, { family }) => ({
    ...state,
    family,
    loading: false
  })),
  on(updateFamilyFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(deleteFamily, (state, { id }) => ({
    ...state,
    families: state.families.map(family =>
      String(family.id) === id ? { ...family, disabled: true } : family
    )
  })),
  on(deleteFamilySuccess, (state, { id }) => {
    // Update the business state to reflect that it is successfully deleted
    const updatedState = {
      ...state,
      families: state.families.filter(b => b.id !== id), // Remove the business from the list
      error: null
    }
    return updatedState
  }),
  on(deleteFamilyFailure, (state, { error }) => ({
    ...state,
    error
  }))
)

// Create the feature for the business state
export const familyFeature = createFeature({
  name: 'family', // Feature name
  reducer: familyReducer
})
export type { FamilyState }
// Export the feature's selectors
export const { name, reducer, selectFamilies, selectLoading, selectError } = familyFeature
